import React, { useState, useEffect } from 'react'
import Select from 'react-select'
import { CButton, CCard, CCardBody, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CFormLabel, CFormTextarea, CFormInput, CSpinner, CNav, CNavItem, CNavLink, CCardHeader, CCardTitle, CCardText, CCol, CTabContent, CTabPane } from '@coreui/react'
import { CircleAlertIcon, Pencil, Trash2, ListOrdered, Info, AlignLeft, CirclePlus } from 'lucide-react'
import CustomAgGrid from './../../components/shared/CustomAgGrid'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import Pageloader from '../../components/shared/Pageloader'
import AccordianEditDelete from '../../components/shared/AccordianEditDelete'
import SaveExtra from '../../services/general/saveExtraData.api'
import AccordianSuggestion from './AccordianSuggestion'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import { motion } from 'framer-motion'
import AddSuggestionTitle from './AddSuggestionTitle'
import PlanStatement from './PlanStatement'
import DifferentialCopy from './DifferentialCopy'
const AssesmentPlanSuggestion = ({ parentDiagnosis, closeEditModel, fetchData, LinkFor = 'assessment', setLinkData, setLinkModel, handleSubmitLinkData, linkData, addFormMade }) => {
  const [diagnosisData, setDiagnosisData] = useState([])
  const [modalVisible, setModalVisible] = useState(false)
  const [suggestionModalVisible, setSuggestionModalVisible] = useState(false)
  const [isEditing, setIsEditing] = useState(false)
  const [currentDiagnosisId, setCurrentDiagnosisId] = useState(null)
  const [selectedDiagnosis, setSelectedDiagnosis] = useState(null)
  const [diagnosisOptions, setDiagnosisOptions] = useState([])
  const [assessment, setAssessment] = useState([])
  const [plans, setPlans] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [deleteVisibleId, setDeleteVisibleId] = useState(null)
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [activeTab, setActiveTab] = useState(0)
  const [suggestionId, setSuggestionId] = useState(null)

  const [accordions, setAccordions] = useState({ diagnosis: null, accordions: linkData || [] } || [])
  const [currentParentId, setCurrentParentId] = useState(null)
  const [newTitle, setNewTitle] = useState('')
  const [newCode, setNewCode] = useState('')
  const [suggestionTitle, setSuggestionTitle] = useState([])
  const [editMode, setEditMode] = useState(false)
  const [editingAccordionId, setEditingAccordionId] = useState(null)

  const [suggestionData, setSuggestionData] = useState([])
  const [suggestionIndex, setSuggestionIndex] = useState(null)

  const [saveResoanChange, setSaveResoanChange] = useState({})
  const [openSelectedAccordian, setOpenSelectedAccordian] = useState(null)
  const [activeDescriptions, setActiveDescriptions] = useState(null)
  const [fileStatmentData, setFileStatmentData] = useState({
    attachedIndex: '',
    parentId: '',
    name: '',
  })
  const [order, setOrder] = useState([])
  const [planSuggestions, setPlanSuggestions] = useState([])
  const [file, setFile] = useState([])
  const [titleList, setTitleList] = useState([])
  const [showTitleFooter, setShowTitleFooter] = useState(true)

  const saveToLocalStorage = (data) => {
    // localStorage.setItem('SuggestionDiagnosis', JSON.stringify(data));
  }

  useEffect(() => {
    if (selectedDiagnosis) {
      let result = suggestionData.filter((item) => item?.Data.diagnosis.value === selectedDiagnosis?.value)

      if (result.length > 0) {
        setAccordions(result[0].Data)
      } else {
        setAccordions({ diagnosis: selectedDiagnosis || null, accordions: [] })
      }
    }
  }, [selectedDiagnosis])

  const addAccordion = (parentId = null) => {
    if (editMode) {
      setAccordions((prev) => {
        const updatedAccordions = updateAccordionTitle(prev.accordions, editingAccordionId, {
          title: newTitle,
          code: newCode,
        })
        const updatedData = { ...prev, accordions: updatedAccordions }
        saveToLocalStorage(updatedData)
        return updatedData
      })
      setEditMode(false)
      setNewTitle(null)
      setNewCode('')
    } else {
      const newAccordion = {
        id: Date.now(),
        title: newTitle,
        code: newCode,
        description: '',
        suggestions: {
          suggestionName: [],
          orders: [],
          planSuggestions: [],
          information: [],
        },
        children: [],
      }

      setAccordions((prev) => {
        const updatedAccordions = parentId ? updateNestedAccordions(prev.accordions, parentId, newAccordion) : [...prev?.accordions, newAccordion]

        const updatedData = { ...prev, accordions: updatedAccordions }
        saveToLocalStorage(updatedData)
        return updatedData
      })
    }

    closeModal()
  }

  const updateAccordionTitle = (list, accordionId, updatedFields) => list.map((item) => (item.id === accordionId ? { ...item, ...updatedFields } : { ...item, children: updateAccordionTitle(item.children, accordionId, updatedFields) }))

  const updateNestedAccordions = (list, parentId, newAccordion) => list.map((item) => (item.id === parentId ? { ...item, children: [...item.children, newAccordion] } : { ...item, children: updateNestedAccordions(item.children, parentId, newAccordion) }))

  const editAccordion = (accordionId, currentTitle, currentCode = '') => {
    setEditMode(true)
    setEditingAccordionId(accordionId)
    setNewTitle(currentTitle)
    setNewCode(currentCode)
    setModalVisible(true)
  }

  // const addSuggestion = (parentId) => {

  //     let suggestionText = suggestionTitle;
  //     if (suggestionText) {
  //         setAccordions((prev) => {
  //             const updatedSuggestions = updateNestedSuggestions(prev.accordions, parentId, suggestionText);
  //             const updatedData = { ...prev, accordions: updatedSuggestions };
  //             saveToLocalStorage(updatedData);
  //             return updatedData;
  //         });
  //     }
  //     setSuggestionTitle([])
  //     setSuggestionModalVisible(false)
  // };

  const addSuggestion = (parentId = null) => {
    let suggestionText = suggestionTitle
    if (suggestionText) {
      setAccordions((prev) => {
        let updatedAccordions = prev.accordions
        if (!updatedAccordions || updatedAccordions.length === 0) {
          const newAccordion = {
            id: Date.now(),
            title: null,
            suggestions: {
              suggestionName: suggestionText,
              orders: [],
              planSuggestions: [],
              information: [],
            },
            children: [],
          }
          updatedAccordions = [newAccordion]
        } else {
          updatedAccordions = updateNestedSuggestions(updatedAccordions, parentId, suggestionText)
        }

        const updatedData = { ...prev, accordions: updatedAccordions }
        saveToLocalStorage(updatedData)
        return updatedData
      })
    }
    setSuggestionTitle([])
    setSuggestionModalVisible(false)
  }

  const updateNestedSuggestions = (list, parentId, suggestion) =>
    list.map((item) =>
      item.id === parentId
        ? {
            ...item,
            suggestions: {
              ...item.suggestions,
              suggestionName: suggestion,
              orders: [],
              planSuggestions: [],
            },
          }
        : {
            ...item,
            children: updateNestedSuggestions(item.children, parentId, suggestion),
          },
    )

  const openModal = (parentId = null) => {
    setCurrentParentId(parentId)
    setModalVisible(true)
  }

  const closeModal = () => {
    setModalVisible(false)
    setNewTitle('')
    setNewCode('')
    setEditingAccordionId(null)
    setEditMode(false)
  }

  const deleteAccordion = (parentId) => {
    setDeleteVisibleId(parentId)
  }
  const removeAccordionById = (list, accordionId) =>
    list
      .filter((item) => item.id !== accordionId)
      .map((item) => ({
        ...item,
        children: removeAccordionById(item.children, accordionId),
      }))

  const deleteDiagnosis = async (e) => {
    let localData = JSON.parse(localStorage.getItem('SuggestionDiagnosis')) || []
    const updatedData = localData.filter((diagnosis) => diagnosis.id !== deleteVisibleId?.id)
    localStorage.setItem('SuggestionDiagnosis', JSON.stringify(updatedData))

    // Update state data
    getData()
    setDeleteVisibleId(null)
    setDiagnosisData(updatedData)
  }

  const handleOnClick = () => {
    setIsEditing(false)
    setCurrentDiagnosisId(null)
    // setSelectedDiagnosis(null);
    setAssessment([])
    setPlans([])
    setModalVisible(true)
    setCurrentParentId(null)
    // setSelectedSuggestion(null)
  }

  const handelSaveandClose = async () => {
    await handelSubmit()
    if (typeof closeEditModel === 'function') {
      closeEditModel()
    }
    if (typeof setLinkModel === 'function') {
      setLinkModel(false)
    }
  }

  const handelSubmit = async (shouldToast = true) => {
    setIsLoading(true)
    try {
      if (LinkFor == 'assessment') {
        if (!selectedDiagnosis) {
          alert('Please select a diagnosis.')
          return
        }

        let localData = JSON.parse(localStorage.getItem('SuggestionDiagnosis')) || []

        let SuggestionData = suggestionData.filter((item) => item?.Data?.diagnosis?.value === selectedDiagnosis.value)
        if (SuggestionData.length > 0) {
          await SaveExtra('Update', 'AssesmentSuggestions', JSON.stringify(accordions), SuggestionData[0].Id)
        } else {
          await SaveExtra('Insert', 'AssesmentSuggestions', JSON.stringify(accordions))
        }
        if (shouldToast) {
          toast.success('Saved', toastConfig)
        }
        // setModalVisible(false);
        setSaveResoanChange({})
        getData()
        fetchData()
      } else if (LinkFor == 'HPI') {
        setLinkData(accordions?.accordions)
        // addFormMade()
        if (shouldToast) {
          toast.success('Saved', toastConfig)
        }
        // setLinkModel(false)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  const handelAutoSubmit = async () => {
    setIsLoading(true)
    try {
      if (LinkFor == 'assessment') {
        if (!selectedDiagnosis) {
          alert('Please select a diagnosis.')
          return
        }

        let localData = JSON.parse(localStorage.getItem('SuggestionDiagnosis')) || []

        let SuggestionData = suggestionData.filter((item) => item?.Data?.diagnosis?.value === selectedDiagnosis.value)
        if (SuggestionData.length > 0) {
          await SaveExtra('Update', 'AssesmentSuggestions', JSON.stringify(accordions), SuggestionData[0].Id)
        } else {
          await SaveExtra('Insert', 'AssesmentSuggestions', JSON.stringify(accordions))
        }

        // setModalVisible(false);
        setSaveResoanChange({})
        getData()
        fetchData()
      } else if (LinkFor == 'HPI') {
        setLinkData(accordions)
        addFormMade()
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  const getData = async () => {
    setIsPageLoading(true)
    try {
      let response = await GetDiagnosisData('')
      let diagnosis = JSON.parse(response.d)?.Data
      let data = await SaveExtra('Get_By_Type', 'AssesmentSuggestions', '', '')
      data = JSON.parse(data.d)?.Data || []
      if (data) {
        data = data?.map((item) => {
          return {
            Id: item.Id,
            Data: JSON.parse(item?.JsonData),
          }
        })
      }
      setSuggestionData(data)
      updateDiagnosisOptions(diagnosis)
      setSelectedDiagnosis(parentDiagnosis)
    } catch (error) {
      console.log(error)
    } finally {
      setIsPageLoading(false)
    }
  }

  const updateDiagnosisOptions = (data) => {
    const options = data.map((item) => ({
      value: item.id,
      label: item.Name,
    }))
    setDiagnosisOptions(options)
  }

  useEffect(() => {
    getData()
  }, [])

  const editSuggestion = (parentId, suggestionIndex) => {
    const newSuggestion = suggestionTitle

    if (newSuggestion) {
      setAccordions((prev) => {
        const updatedSuggestions = updateEditNestedSuggestions(prev.accordions, parentId, suggestionIndex, newSuggestion)
        const updatedData = { ...prev, accordions: updatedSuggestions }
        saveToLocalStorage(updatedData)
        return updatedData
      })
    }
    setSuggestionTitle([])
    setEditMode(false)
    setSuggestionModalVisible(false)
    setSuggestionIndex(null)
  }

  const updateEditNestedSuggestions = (list, parentId, suggestionIndex, newSuggestion) =>
    list.map((item) =>
      item.id === parentId
        ? {
            ...item,
            suggestions: {
              ...item.suggestions,
              suggestionName: newSuggestion,
            },
          }
        : {
            ...item,
            children: item.children ? updateEditNestedSuggestions(item.children, parentId, suggestionIndex, newSuggestion) : item.children,
          },
    )

  const handleSuggestionsChange = (updatedSuggestions, parentId) => {
    setAccordions((prev) => {
      const updatedData = {
        ...prev,
        accordions: updateNestedSuggestionsResoan(prev.accordions, parentId, updatedSuggestions),
      }

      return updatedData
    })
    return true
  }

  const updateNestedSuggestionsResoan = (list, parentId, updatedSuggestions) =>
    list.map((item) =>
      item.id === parentId
        ? { ...item, suggestions: { ...item.suggestions, orders: updatedSuggestions } }
        : {
            ...item,
            children: updateNestedSuggestionsResoan(item.children || [], parentId, updatedSuggestions),
          },
    )

  const handlePlanSuggestionsChange = (updatedPlanSuggestions, parentId) => {
    setAccordions((prev) => {
      const updatedData = {
        ...prev,
        accordions: updatePlanSuggestionsForParent(prev.accordions, parentId, updatedPlanSuggestions),
      }

      return updatedData
    })
    return true
  }

  const updatePlanSuggestionsForParent = (list, parentId, updatedPlanSuggestions) =>
    list.map((item) =>
      item.id === parentId
        ? {
            ...item,
            suggestions: {
              ...item.suggestions,
              planSuggestions: updatedPlanSuggestions,
            },
          }
        : {
            ...item,
            children: updatePlanSuggestionsForParent(item.children || [], parentId, updatedPlanSuggestions),
          },
    )

  useEffect(() => {
    if (accordions?.accordions?.length === 0) {
      addSuggestion()
    }
  }, [accordions])

  const [titleDescriptionId, setTitleDescriptionId] = useState('')
  const [descriptionText, setDescriptionText] = useState('')

  const handleAddTitleDescription = (item) => {
    setDescriptionText(item.description)
    setTitleDescriptionId(item.id)
  }

  const handleSaveDescription = () => {
    try {
      const updateDescriptionInNestedChildren = (data, id, descriptionText) => {
        if (!data || !Array.isArray(data)) {
          return false
        }

        for (const item of data) {
          if (item.id === id) {
            item.description = descriptionText

            return true
          }
          if (item.children && Array.isArray(item.children)) {
            const updated = updateDescriptionInNestedChildren(item.children, id, descriptionText)
            if (updated) return true
          }
        }
        return false
      }

      let updated = false
      if (accordions?.accordions) {
        updated = updateDescriptionInNestedChildren(accordions.accordions, titleDescriptionId, descriptionText)
      }

      if (updated) {
        toast.success('Description Saved', toastConfig)
      } else {
        console.log('Item not found.')
      }

      // setDescriptionText("")
      setTitleDescriptionId('')
      setActiveDescriptions(null)
    } catch (error) {
      console.log(error)
    }
  }

  const [descriptionStatementId, setDescriptionStatementId] = useState({
    orderIndex: '',
    parentId: '',
    name: '',
  })

  const [showDescriptionStatementModal, setShowDescriptionStatementModal] = useState(false)
  const [descriptionStatementText, setDescriptionStatementText] = useState('')

  const handleAddStatementDescription = (item, descriptionText) => {
    setShowDescriptionStatementModal(true)
    setDescriptionStatementId(item)
    setDescriptionStatementText(descriptionText)
  }

  const handleDescriptionStatementSubmit = () => {
    let isUpdated = false
    const updateNestedAccordion = (accordionList) => {
      return accordionList.map((accordion) => {
        if (accordion.id === descriptionStatementId.parentId) {
          const updatedSuggestionName = [...accordion.suggestions.suggestionName]

          updatedSuggestionName.forEach((suggestion) => {
            if (suggestion.name === descriptionStatementId.name) {
              suggestion.description = descriptionStatementText
            }
          })
          isUpdated = true
          return {
            ...accordion,
            suggestions: {
              ...accordion.suggestions,
              suggestionName: updatedSuggestionName,
            },
          }
        }

        if (accordion.children && accordion.children.length > 0) {
          return {
            ...accordion,
            children: updateNestedAccordion(accordion.children),
          }
        }

        return accordion
      })
    }

    const updatedAccordions = updateNestedAccordion(accordions.accordions)
    accordions.accordions = updatedAccordions

    setDescriptionStatementId({
      name: '',
      parentId: '',
    })

    setActiveDescriptions(null)

    if (isUpdated) {
      toast.success('Description Saved', toastConfig)
    }
  }

  const handleDeleteData = (parentId) => {
    setAccordions((prev) => {
      const updatedAccordions = removeAccordionById(prev.accordions, parentId)
      const updatedData = { ...prev, accordions: updatedAccordions }
      return updatedData
    })
    setDeleteVisibleId(null)
  }

  const handleTitleParentMediaId = (parentId) => {
    setCurrentParentId(parentId)
  }

  const handleTitleFileSave = (deleteFile = null) => {
    setAccordions((prevData) => {
      const updateAttachment = (data, files) =>
        data?.map((item) =>
          item.id === currentParentId
            ? {
                ...item,
                attached: {
                  image: [...(item.attached?.image ?? []).filter((f) => f.url !== deleteFile), ...files.filter((f) => f.type === 'image' && !(item.attached?.image ?? []).some((existing) => existing.url === f.url)).map((f) => ({ url: f.url, fileName: f.fileName, publicId: f.publicId, id: f.id }))],

                  video: [...(item.attached?.video ?? []).filter((f) => f.url !== deleteFile), ...files.filter((f) => f.type === 'video' && !(item.attached?.video ?? []).some((existing) => existing.url === f.url)).map((f) => ({ url: f.url, fileName: f.fileName, publicId: f.publicId, id: f.id }))],

                  document: [
                    ...(item.attached?.document ?? []).filter((f) => f.url !== deleteFile),
                    ...files.filter((f) => f.type !== 'image' && f.type !== 'video' && !(item.attached?.document ?? []).some((existing) => existing.url === f.url)).map((f) => ({ url: f.url, fileName: f.fileName, publicId: f.publicId, id: f.id })),
                  ],
                },
              }
            : { ...item, children: updateAttachment(item.children, files) },
        ) ?? data

      return prevData?.accordions ? { ...prevData, accordions: updateAttachment(prevData.accordions, file) } : (console.log('Item not found.'), prevData)
    })
  }

  const handleFileStatementData = (item) => {
    setFileStatmentData(item)
  }
  const handleStatementFileSave = (deleteFile = null) => {
    setAccordions((prevData) => {
      const updateNestedAccordion = (accordionList) =>
        accordionList?.map((accordion) =>
          accordion.id === fileStatmentData.parentId
            ? {
                ...accordion,
                suggestions: {
                  ...accordion.suggestions,
                  suggestionName: accordion.suggestions.suggestionName.map((suggestion) =>
                    suggestion.name === fileStatmentData.name
                      ? {
                          ...suggestion,
                          attached: {
                            image: [
                              ...(suggestion.attached?.image ?? []).filter((f) => f.url !== deleteFile),
                              ...file.filter((f) => f.type === 'image' && !(suggestion.attached?.image ?? []).some((existing) => existing.url === f.url)).map((f) => ({ url: f.url, fileName: f.fileName, publicId: f.publicId, id: f.id })),
                            ],

                            video: [
                              ...(suggestion.attached?.video ?? []).filter((f) => f.url !== deleteFile),
                              ...file.filter((f) => f.type === 'video' && !(suggestion.attached?.video ?? []).some((existing) => existing.url === f.url)).map((f) => ({ url: f.url, fileName: f.fileName, publicId: f.publicId, id: f.id })),
                            ],

                            document: [
                              ...(suggestion.attached?.document ?? []).filter((f) => f.url !== deleteFile),
                              ...file.filter((f) => f.type !== 'image' && f.type !== 'video' && !(suggestion.attached?.document ?? []).some((existing) => existing.url === f.url)).map((f) => ({ url: f.url, fileName: f.fileName, publicId: f.publicId, id: f.id })),
                            ],
                          },
                        }
                      : suggestion,
                  ),
                },
              }
            : { ...accordion, children: updateNestedAccordion(accordion.children) },
        ) ?? accordionList

      return prevData?.accordions ? { ...prevData, accordions: updateNestedAccordion(prevData.accordions) } : prevData
    })
  }

  const renderAccordions = (list, children = false) => {
    const visibleAccordions = (list || []).filter((item) => {
      const hasTitle = Boolean(item?.title?.toString().trim())
      const hasSuggestionContent =
        Boolean(item?.suggestions?.suggestionName?.length) ||
        Boolean(item?.suggestions?.orders?.length) ||
        Boolean(item?.suggestions?.planSuggestions?.length) ||
        Boolean(item?.suggestions?.information?.length)
      const hasChildren = Boolean(item?.children?.length)

      return hasTitle || hasSuggestionContent || hasChildren
    })

    return (
      <div className="  ">
        {visibleAccordions?.map((item, i) => {
          return (
            <div key={item.id}>
              <AccordianEditDelete
                title={item.code ? `${item.title} [${item.code}]` : item.title}
                accordion={item}
                handleAddTitleDescription={handleAddTitleDescription}
                isFirst={true}
                editAccordion={editAccordion}
                deleteAccordion={deleteAccordion}
                setActiveDescriptions={setActiveDescriptions}
                setParentAccordions={setAccordions}
                parentId={item.id}
                file={file}
                setFile={setFile}
                handleTitleFileSave={handleTitleFileSave}
                type={'AssesmentSuggestions'}
                attachedType={'title'}
                handleTitleParentMediaId={handleTitleParentMediaId}
                index={i}
                differentModuleCopyFunctionality={true}
                handelSubmit={handelSubmit}
                content={
                  <div key={item.id}>
                    {item.title && (
                      <div className="d-flex gap-2 justify-content-center " style={{ marginTop: '10px' }}>
                        <CButton
                          variant="outline"
                          color="warning"
                          onClick={() => openModal(item.id)}
                          className="assessment-plan-suggestion-theme__action-pill assessment-plan-suggestion-theme__action-pill--warning"
                          style={{
                            padding: '5px 14px',
                            borderRadius: '100px',
                            fontSize: '12px',
                            fontWeight: '500',
                          }}
                        >
                          Add/Edit Title
                        </CButton>
                        <CButton
                          variant="outline"
                          color="primary"
                          onClick={() => {
                            if (item.suggestions && !Array.isArray(item.suggestions) && item?.suggestions?.suggestionName.length > 0) {
                              item?.suggestions?.suggestionName?.map((s, index) => {
                                setSuggestionId(item.id)
                                setSuggestionModalVisible(true)
                                setSuggestionIndex(index)
                                setEditMode(true)
                                setSuggestionTitle(() => {
                                  let data = item?.suggestions?.suggestionName
                                  return data
                                })
                                setOrder(() => {
                                  let data = item?.suggestions?.orders
                                  return data
                                })
                                setPlanSuggestions(() => {
                                  let data = item?.suggestions?.planSuggestions
                                  return data
                                })
                              })
                            } else {
                              setSuggestionId(item.id)
                              setSuggestionModalVisible(true)
                            }
                          }}
                          className="assessment-plan-suggestion-theme__action-pill assessment-plan-suggestion-theme__action-pill--primary"
                          style={{
                            padding: '5px 14px',
                            borderRadius: '100px',
                            fontSize: '12px',
                            fontWeight: '500',
                          }}
                        >
                          Add/Edit Statement
                        </CButton>
                      </div>
                    )}

                    {item.suggestions && (
                      <ul className="list-group  mx-4  ">
                        <AccordianSuggestion
                          suggestions={item?.suggestions?.suggestionName}
                          parentId={item.id}
                          orders={item?.suggestions?.orders}
                          onSuggestionsChange={handleSuggestionsChange}
                          setSaveResoanChange={setSaveResoanChange}
                          planSuggestions={item?.suggestions?.planSuggestions}
                          selectedDiagnosis={selectedDiagnosis}
                          handlePlanSuggestionsChange={handlePlanSuggestionsChange}
                          setOpenSelectedAccordian={setOpenSelectedAccordian}
                          setParentAccordions={setAccordions}
                          information={item?.suggestions?.information || []}
                          setActiveDescriptions={setActiveDescriptions}
                          handleAddStatementDescription={handleAddStatementDescription}
                          handleFileStatementData={handleFileStatementData}
                          handleStatementFileSave={handleStatementFileSave}
                          fileStatmentData={fileStatmentData}
                          file={file}
                          setFile={setFile}
                          attachedType={'statement'}
                          ApiCallingType={'AssesmentSuggestions'}
                          differentModuleCopyFunctionality={true}
                          handelSubmit={handelSubmit}
                        />
                      </ul>
                    )}

                    {item.children.length > 0 && <div className="mt-4">{renderAccordions(item.children, (children = true))}</div>}
                  </div>
                }
              />
            </div>
          )
        })}
      </div>
    )
  }

  const renderOrder = (list, index) => {
    return (
      <>
        {list?.map((item) => {
          return (
            <div key={item.id}>
              {item.suggestions && (
                <ul className="list-group ">
                  <AccordianSuggestion
                    suggestions={item?.suggestions?.suggestionName}
                    parentId={item.id}
                    orders={item?.suggestions?.orders}
                    onSuggestionsChange={handleSuggestionsChange}
                    setSaveResoanChange={setSaveResoanChange}
                    planSuggestions={item?.suggestions?.planSuggestions}
                    selectedDiagnosis={selectedDiagnosis}
                    handlePlanSuggestionsChange={handlePlanSuggestionsChange}
                    showHeader={false}
                    openSelectedAccordian={openSelectedAccordian}
                    checkTrue={true}
                    setOpenSelectedAccordian={setOpenSelectedAccordian}
                    information={item?.suggestions?.information || []}
                    setActiveDescriptions={setActiveDescriptions}
                    handleAddStatementDescription={handleAddStatementDescription}
                    differentModuleCopyFunctionality={true}
                    handelSubmit={handelSubmit}
                  />
                </ul>
              )}

              {item.children.length > 0 && <div className="">{renderOrder(item.children)}</div>}
            </div>
          )
        })}
      </>
    )
  }


  console.log('accordions', accordions)
  return (
    <>
      <div className="assessment-plan-suggestion-theme" data-theme={localStorage.getItem('provio_theme') || 'dark'}>
        <div>
          <div className="d-flex justify-content-between border-bottom assessment-plan-suggestion-theme__header">
            <p className="p-2 m-0 text-center w-50 border-end assessment-plan-suggestion-theme__header-title" style={{ fontWeight: '600' }}>
              Assessment
            </p>
            <p className="p-2 m-0 text-center w-50 assessment-plan-suggestion-theme__header-title" style={{ fontWeight: '600' }}>
              Add To Plan
            </p>
          </div>
          <motion.div className="assessment-plan-suggestion-theme__surface rounded-3 position-relative" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} style={{ height: '70vh', overflow: 'auto' }}>
            <div className="d-flex flex-column h-100 ">
              <div className="d-flex flex-grow-1 h-100">
                <CCol className="d-flex flex-column align-items-center justify-content-start gap-2 border-end p-3 assessment-plan-suggestion-theme__column" style={{ width: '50%', overflowY: 'auto', height: '100%' }}>
                  <div className="  w-100 " style={{ height: '100%' }}>
                    <div className="d-flex justify-content-center  gap-3 ">
                      <CButton
                        variant="outline"
                        color="warning"
                        onClick={handleOnClick}
                        className="assessment-plan-suggestion-theme__action-pill assessment-plan-suggestion-theme__action-pill--warning"
                        style={{
                          padding: '5px 14px',
                          borderRadius: '100px',  
                          fontSize: '12px',
                          fontWeight: '500',
                        }}
                      >
                        Add/Edit Title
                      </CButton>
                      <CButton
                        variant="outline"
                        color="primary"
                        onClick={() => {
                          // setSuggestionIndex(index)
                          setSuggestionModalVisible(true)

                          if (accordions?.accordions.length > 0) {
                            setEditMode(true)
                            setSuggestionId(accordions?.accordions[0]?.id)
                            setSuggestionTitle(() => {
                              let data = accordions?.accordions[0]?.suggestions?.suggestionName
                              return data
                            })
                            setOrder(() => {
                              let data = accordions?.accordions[0]?.suggestions?.orders
                              return data
                            })
                            setPlanSuggestions(() => {
                              let data = accordions?.accordions[0]?.suggestions?.planSuggestions
                              return data
                            })
                          } else {
                            setSuggestionId(null)
                          }
                        }}
                        className="assessment-plan-suggestion-theme__action-pill assessment-plan-suggestion-theme__action-pill--primary"
                        style={{
                          padding: '5px 14px',
                          borderRadius: '100px',
                          fontSize: '12px',
                          fontWeight: '500',
                        }}
                      >
                        Add/Edit Statement
                      </CButton>
                    </div>
                    {renderAccordions(accordions?.accordions)}
                  </div>
                </CCol>

                <CCol className="d-flex flex-column align-items-center justify-content-start p-3 assessment-plan-suggestion-theme__column" style={{ width: '50%', overflowY: 'auto', height: '100%' }}>
                  <div className=" w-100" style={{ height: '100%' }}>
                    {renderOrder(accordions?.accordions)}
                  </div>
                </CCol>
              </div>
            </div>
          </motion.div>
        </div>
        <hr className="assessment-plan-suggestion-theme__divider" />
        <div className=" text-end p-2 assessment-plan-suggestion-theme__footer ">
          <CButton
            color="primary"
            onClick={() => {
              handelSubmit()
            }}
            className="px-4 ui-action-btn ui-action-btn--primary"
            style={{ marginRight: '20px' }}
          >
            Save
          </CButton>
          <CButton
            color="primary"
            onClick={() => {
              handelSaveandClose()
            }}
            className="px-4 ui-action-btn ui-action-btn--primary"
            style={{ marginRight: '20px' }}
          >
            Save & Close
          </CButton>
          <CButton color="secondary" onClick={closeEditModel} className="px-4 ui-action-btn ui-action-btn--secondary">
            Close
          </CButton>
        </div>

        <CModal
          className="patient-theme-modal assessment-plan-suggestion-theme__modal"
          backdrop="static"
          size="lg"
          visible={modalVisible}
          onClose={() => {
            setModalVisible(false)
            setAssessment([])
            setPlans([])
            setEditMode(false)
            setNewTitle(null)
            setNewCode('')
          }}
        >
          <CModalHeader
            onClose={() => {
              setModalVisible(false)
              setAssessment([])
              setPlans([])
              setEditMode(false)
              setNewTitle(null)
              setNewCode('')
            }}
          >
            <CModalTitle>{editMode ? 'Edit Title' : 'Add Title'}</CModalTitle>
          </CModalHeader>
          <CModalBody className="assessment-plan-suggestion-theme__modal-body">
            {modalVisible && (
              <>
                <div className="mt-0 p-2 rounded assessment-plan-suggestion-theme__modal-panel">
                  <AddSuggestionTitle
                    handleSubmitWhenTabChange={handelSubmit}
                    newTitle={newTitle}
                    setNewTitle={setNewTitle}
                    newCode={newCode}
                    setNewCode={setNewCode}
                    setParentAccordions={setAccordions}
                    parentId={currentParentId}
                    handelAutoSubmit={handelAutoSubmit}
                    setModalVisible={setModalVisible}
                    addAccordion={addAccordion}
                    LinkFor={LinkFor}
                    differentModuleCopyFunctionality={true}
                    accordions={accordions}
                    setShowTitleFooter={setShowTitleFooter}
                  />
                </div>
              </>
            )}
          </CModalBody>
          {showTitleFooter && (
            <>
              <hr />
              <CModalFooter className="assessment-plan-suggestion-theme__modal-footer">
                <CButton
                  color="secondary"
                  className="ui-action-btn ui-action-btn--secondary"
                  onClick={() => {
                    setModalVisible(false)
                    // setKeywords([]);
                    setPlans([])
                    setEditingAccordionId(null)
                    setEditMode(false)
                    setNewTitle(null)
                    setNewCode('')
                  }}
                >
                  Close
                </CButton>
                <CButton onClick={() => addAccordion(currentParentId)} className="ui-action-btn ui-action-btn--primary">
                  {isLoading ? (
                    <>
                      <CSpinner component="span" size="sm" variant="grow" aria-hidden="true" />
                      Loading...
                    </>
                  ) : editMode ? (
                    'Save'
                  ) : (
                    'Save'
                  )}
                </CButton>
              </CModalFooter>
            </>
          )}
        </CModal>

        <CModal className="patient-theme-modal assessment-plan-suggestion-theme__modal" backdrop="static" visible={deleteVisibleId}>
          <CModalHeader>
            <CModalTitle>Warning</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
          </CModalBody>
          <hr className="p-0 m-0" />
          <CModalFooter className="p-3 m-0">
            <CButton
              onClick={() => {
                setDeleteVisibleId(null)
              }}
              className="text-white"
              color="secondary"
            >
              Close
            </CButton>
            <CButton onClick={deleteDiagnosis} className="text-white" color="danger">
              Delete
            </CButton>
          </CModalFooter>
        </CModal>

        <CModal
          className="patient-theme-modal assessment-plan-suggestion-theme__modal"
          size="lg"
          backdrop="static"
          visible={suggestionModalVisible}
          onClose={() => {
            setSuggestionModalVisible(false)
            setSuggestionTitle([])
            setEditMode(false)
          }}
        >
          <CModalHeader
            onClose={() => {
              setSuggestionModalVisible(false)
              setSuggestionTitle([])
              setEditMode(false)
            }}
          >
            <CModalTitle>{isEditing ? 'Edit Statement' : 'Add Statement'}</CModalTitle>
          </CModalHeader>
          <CModalBody className="assessment-plan-suggestion-theme__modal-body">
            {suggestionModalVisible && (
              <>
                <div className="mt-0 p-2 py-4 rounded assessment-plan-suggestion-theme__modal-panel">
                  <div className="w-100">
                    <div className="w-100 p-3 rounded pe-title-card assessment-plan-suggestion-theme__statement-panel">
                      <PlanStatement
                        className="mb-3"
                        label="Statement"
                        handleSubmitWhenTabChange={handelSubmit}
                        keywords={suggestionTitle}
                        order={order}
                        setOrder={setOrder}
                        planSuggestions={planSuggestions}
                        setPlanSuggestions={setPlanSuggestions}
                        setKeywords={setSuggestionTitle}
                        setParentAccordions={setAccordions}
                        parentId={suggestionId}
                        setSuggestionModalVisible={setSuggestionModalVisible}
                        differentModuleCopyFunctionality={true}
                        handleSuggestionsChange={handleSuggestionsChange}
                        handlePlanSuggestionsChange={handlePlanSuggestionsChange}
                      />
                    </div>
                    <div>
                      {/* <AccordianSuggestion
                                                suggestions={suggestionTitle}
                                                onSuggestionsChange={handleSuggestionsChange}
                                                parentId={suggestionId}
                                            /> */}
                    </div>
                  </div>
                </div>
              </>
            )}
          </CModalBody>

          <CModalFooter className="assessment-plan-suggestion-theme__modal-footer">
            <CButton
              color="secondary"
              className="ui-action-btn ui-action-btn--secondary"
              onClick={() => {
                setSuggestionModalVisible(false)
                setSuggestionTitle([])
                setEditMode(false)
              }}
            >
              Close
            </CButton>
            <CButton
              color="primary"
              className="ui-action-btn ui-action-btn--primary"
              onClick={() => {
                ;(setSuggestionModalVisible(false), editMode ? editSuggestion(suggestionId, suggestionIndex) : addSuggestion(suggestionId))
              }}
            >
              {isLoading ? (
                <>
                  <CSpinner component="span" size="sm" variant="grow" aria-hidden="true" />
                  Loading...
                </>
              ) : (
                'Save'
              )}
            </CButton>
          </CModalFooter>
        </CModal>

        {/* description tab */}
        <CModal className="patient-theme-modal assessment-plan-suggestion-theme__modal" size="lg" alignment="top" backdrop="static" visible={activeDescriptions} onClose={() => setActiveDescriptions(null)} aria-labelledby="VerticallyCenteredExample">
          <CModalHeader className="text-warning">
            <CModalTitle id="VerticallyCenteredExample" className=" ">
              Description
            </CModalTitle>
          </CModalHeader>
          <CModalBody className="assessment-plan-suggestion-theme__modal-body">
            <div>
              <div className="pe-tab-underline-nav mb-4">
                <CNav role="tablist" className="justify-content-center">
                  <CNavItem>
                    <CNavLink active={activeTab === 0} onClick={() => setActiveTab(0)}>
                      New
                    </CNavLink>
                  </CNavItem>
                  <CNavItem>
                    <CNavLink
                      active={activeTab === 1}
                      onClick={() => {
                        setActiveTab(1)
                        handelSubmit(false)
                      }}
                    >
                      Copy
                    </CNavLink>
                  </CNavItem>
                </CNav>
              </div>
              <div activeTab={activeTab} onActiveTabChange={setActiveTab}>
                <CTabContent>
                  {activeTab === 0 && (
                    <CTabPane visible={activeTab === 0}>
                      {activeDescriptions == 'statement' && (
                        <div>
                          <div className="mx-5">
                            <CFormTextarea
                              id="descriptionTextarea"
                              label="Enter your description"
                              style={{ height: '200px', color: '#ffc107', caretColor: 'black' }}
                              placeholder="Type your description here..."
                              value={descriptionStatementText}
                              onChange={(e) => {
                                setDescriptionStatementText(e.target.value)
                              }}
                            />
                          </div>

                          <div className="mx-5 my-2 m-0 d-flex justify-content-end gap-2">
                            <CButton
                              color="secondary"
                              className="ui-action-btn ui-action-btn--secondary"
                              onClick={() => {
                                ;(setTitleDescriptionId(''), setActiveDescriptions(null))
                              }}
                            >
                              Close
                            </CButton>
                            <CButton color="primary" onClick={handleDescriptionStatementSubmit} className="ui-action-btn ui-action-btn--primary">
                              Save Description
                            </CButton>
                          </div>
                        </div>
                      )}
                      {activeDescriptions == 'title' && (
                        <div>
                          <div className="mx-5">
                            <CFormTextarea
                              style={{ height: '200px', color: '#ffc107', caretColor: 'black' }}
                              className="form-control"
                              value={descriptionText}
                              onChange={(e) => {
                                setDescriptionText(e.target.value)
                              }}
                              placeholder="Enter Description"
                            ></CFormTextarea>
                          </div>
                          <div className="mx-5 my-2 m-0 d-flex justify-content-end gap-2">
                            <CButton
                              color="secondary"
                              className="ui-action-btn ui-action-btn--secondary"
                              onClick={() => {
                                ;(setTitleDescriptionId(''), setActiveDescriptions(null))
                              }}
                            >
                              Close
                            </CButton>
                            <CButton color="primary" onClick={handleSaveDescription} className="ui-action-btn ui-action-btn--primary">
                              Save Description
                            </CButton>
                          </div>
                        </div>
                      )}
                    </CTabPane>
                  )}
                  {activeTab === 1 && (
                    <CTabPane visible={activeTab === 1} className=" w-100 d-flex flex-column  justify-content-center align-items-center">
                      <div className="w-100">
                        <DifferentialCopy
                          setDescriptionStatementText={setDescriptionStatementText}
                          setActiveTab={setActiveTab}
                          descriptionStatementId={descriptionStatementId}
                          setParentAccordions={setAccordions}
                          ApiCallingType={'AssesmentSuggestions'}
                          parentId={currentParentId}
                          setSuggestionModalVisible={setSuggestionModalVisible}
                          type={'AssesmentSuggestions'}
                          titleDescriptionId={titleDescriptionId}
                          activeDescriptions={activeDescriptions}
                          setDescriptionText={setDescriptionText}
                          differentModuleCopyFunctionality={true}
                        />
                      </div>
                    </CTabPane>
                  )}
                </CTabContent>
              </div>
            </div>
          </CModalBody>
          {/* <CModalFooter>
                        <CButton variant="outline" color="secondary" onClick={() => setActiveDescriptions(null)}>
                            Close
                        </CButton>
                        <CButton
                            variant="outline"

                            color="primary">Save</CButton>
                    </CModalFooter> */}
        </CModal>

        <CModal className="patient-theme-modal assessment-plan-suggestion-theme__modal" backdrop="static" visible={deleteVisibleId} onClose={() => setDeleteVisibleId(null)}>
          <CModalHeader>
            <CModalTitle>Warning</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
          </CModalBody>
          <hr className="p-0 m-0" />
          <CModalFooter className="p-3 m-0">
            <CButton
              onClick={() => {
                setDeleteVisibleId(null)
              }}
              className="text-white"
              color="secondary"
            >
              Close
            </CButton>
            <CButton onClick={() => handleDeleteData(deleteVisibleId)} className="text-white" color="danger">
              Delete
            </CButton>
          </CModalFooter>
        </CModal>
        <Pageloader isLoading={isPageLoading} />
      </div>
    </>
  )
}

export default AssesmentPlanSuggestion
